export enum DropdownType {
  select = 'select',
  dropdown = 'dropdown'
}
